import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetUsersResponse } from '@hud/portal-dtos/webapp-users.dto';
import { PORTAL_BASE } from '../consts';

export const MEMBERS_ID = 'members';

export default function useMembers() {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [MEMBERS_ID],
    queryFn: async () => {
      const response = await client.get<GetUsersResponse>(
        `${PORTAL_BASE}/users`,
      );
      return GetUsersResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
